// Teller Online Files
import { PublicHelpTag } from 'apps/public-portal/src/app/shared/help/help-tags';
import { helpTitle } from 'apps/public-portal/src/app/shared/help/help-titles';

// Teller Online Library Files
import { HelpArticle } from 'teller-online-libraries/help';

export const CART_HELP_ARTICLES: HelpArticle[] = [
    new HelpArticle({
        tag: PublicHelpTag.Cart,
        order: 0,
        bookmark: 'where-is-the-cart',
        title: helpTitle('where-is-the-cart'),
        body: '<p>The cart can be opened at any time by clicking the :shopping_cart: icon '
            + 'in the header at the top of the page. It is available on every page, next to '
            + 'the Help icon.</p>'
    }),
    new HelpArticle({
        tag: PublicHelpTag.Cart,
        order: 6,
        bookmark: 'cart-warning',
        title: helpTitle('cart-warning'),
        body: '<p>When the price of an item you have in your cart has changed since you added it '
            + 'you will see a warning.</p>'
            + '<p>This is most often just a message informing you that there was a change.</p>'
            + '<p>Occasionally, you may be required to take action if the payment option you '
            + 'previously chose is no longer available.</p>'
    }),
    new HelpArticle({
        tag: PublicHelpTag.Cart,
        order: 11,
        bookmark: 'how-remove-item-from-cart',
        title: helpTitle('how-remove-item-from-cart'),
        body: 'You can remove an item from your cart in either place:<ul>'
            + '<li>In your cart, click the :delete: button next to the item you want to '
            + 'remove.</li>'
            + '<li>In the search results or on the item details page, click the <b>Remove From '
            + 'Cart</b> button :remove_shopping_cart: at the bottom of the item card.</li>'
            + '</ul>'
    })
];
